import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
const Odometer = require('odometer/odometer.js');

gsap.registerPlugin(ScrollTrigger);

export default {

	init() {
		console.log('gsap...');
		this.homeIntro();
		//this.pinTextPanels();
		this.pinNewsletterSignup();
		this.pinSharingButtons();
		this.countupNumbers();

		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		let elem = document.querySelector('.newsletter-signup');
		let btn = document.querySelector('button.signup-close');

		if(btn) {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				elem.classList.remove('is-fixed');
				elem.classList.add('is-dismissed');
			});
		}
	},

	homeIntro() {
		if(!document.querySelector('.home-hero')) {
			return;
		}

		window.scrollTo(0, 0, { behavior: 'instant' });

		const animationCallback = function() {
			body.classList.remove('is-intro-animating');
			body.classList.add('is-intro-complete');
		};

		const body = document.querySelector('body');
		body.classList.add('is-intro-animating');

		gsap.set('.site-header', { opacity: 0 });
		gsap.set('.hero-logo', { opacity: 0 });
		gsap.set('.hero-headline', { opacity: 0, y: '+=180' });
		gsap.set('.hero-video', { opacity: 0, y: '+=180' });
		gsap.set('.entry-content', { opacity: 0, y: '+=180' });

		let tl = gsap.timeline({ defaults: { ease: "power2.inOut" } });
		tl.to('.hero-logo', { opacity: 1, duration: 0.15 })
		  .to('.hero-logo', { top: 0, left: 0, width: 'auto', x: '+=50%', y: '+=50%', z: 0, duration: 1, delay: 1 })
		  .to('.hero-overlay', { autoAlpha: 0, duration: 0 }, '-=0.2')
		  .to('.site-header', { opacity: 1, duration: 1 }, '<')
		  .to('.hero-logo', { autoAlpha: 0, duration: 1 }, '<')
		  .to('.hero-headline', { opacity: 1, y: '-=180', duration: 0.75 }, '-=0.75')
		  .to('.hero-video', { opacity: 1, y: '-=180', duration: 0.75 }, '-=0.5')
		  .to('.entry-content', { opacity: 1, y: '-=180', duration: 0.75 }, '-=0.5')
		  .call(animationCallback);
	},

	pinTextPanels() {
		// ...
	},

	pinNewsletterSignup() {
		let elem = document.querySelector('.newsletter-signup');

		if (!elem) {
			return;
		}

		let endElem = document.querySelector('.footer');

		let st = ScrollTrigger.create({
			trigger: elem,
			endTrigger: endElem,
			start: "bottom bottom",
			end: "top bottom",
			markers: false,
			onEnter: (self) => {
				// Scrolling in view - pin
				self.trigger.classList.add('is-fixed', 'animated');
			},
			onLeave: (self) => {
				// Hide pinned element
				let duration = (self.getVelocity() > 3000) ? '0' : '300ms';
				self.trigger.style.setProperty('--animation-duration', duration);
				self.trigger.classList.remove('fade-in-up');
				self.trigger.classList.add('fade-out-down');
			},
			onEnterBack: (self) => {
				// Show pinned element
				let duration = (self.getVelocity() > 3000) ? '0' : '300ms';
				self.trigger.style.setProperty('--animation-duration', duration);
				self.trigger.classList.remove('fade-out-down');
				self.trigger.classList.add('fade-in-up');
			},
			onLeaveBack: (self) => {
				// Unpin
				self.trigger.classList.remove('is-fixed', 'animated', 'fade-in-up', 'fade-out-down');
			},
		});

	},

	pinSharingButtons() {
		let elem = document.querySelector('.meta-sharing');

		if (!elem) {
			return;
		}

		let relElem = document.querySelector('.related-news');
		let endElem = relElem ?? document.querySelector('.footer');

		// Only pin sharing buttons on XL screens
		let mm = gsap.matchMedia();
		mm.add('(min-width: 1280px)', () => {

			let st = ScrollTrigger.create({
				trigger: ".entry-content",
				pin: ".meta-sharing",
				start: "top center-=44px",
				endTrigger: endElem,
				end: "top bottom+=75",
				markers: false,
			});

		});
	},

	countupNumbers() {
		let elems = document.querySelectorAll('[data-countup]');

		if (!elems) {
			return;
		}

		window.odometerOptions = {
			auto: false,
			theme: 'minimal',
			duration: 3000,
		};

		elems.forEach(function (elem) {
			let target = elem.innerText;
			let odometer = new Odometer({
				el: elem,
				value: 0,
			});

			ScrollTrigger.create({
				trigger: elem,
				onToggle: (self) => {
					if(self.isActive) {
						self.trigger.innerText = target;
					}
				},
				markers: false,
			});
		});

	}

}